import * as z from 'zod';

export const mercureSubscription = z.object({
    hubUrl: z.string(),
    topic: z.string(),
    token: z.string().nullable(),
});

export type MercureSubscription = z.infer<typeof mercureSubscription>;
